const EXTRACT_URL = "https://extracts.panmacmillan.com/extract?isbn=";

export const buildExtractUrl = (isbn: string) => `${EXTRACT_URL}${isbn}`;
